export enum PRINT_TYPE {
  DICOM,
  PAPER,
  PDF,
  IMAGE,
}

export const FILE_TYPE_OPTIONS = [
  {
    value: PRINT_TYPE.DICOM,
    label: 'DICOM PRINT',
  },
  {
    value: PRINT_TYPE.PAPER,
    label: 'PAPER PRINT',
  },
  {
    value: PRINT_TYPE.PDF,
    label: 'Save as PDF',
  },
  {
    value: PRINT_TYPE.IMAGE,
    label: 'Save as PNG',
  },
];

export const TEXT_SIZE = [
  { value: 'sm', label: 'Small' },
  { value: 'md', label: 'Medium' },
  { value: 'lg', label: 'Large' },
];

export const FILM_TYPE = [
  { key: '8INX10IN', title: '8INX10IN', ratio: 8 / 10 },
  { key: '8_5INX11IN', title: '8_5INX11IN', ratio: 8.5 / 11 },
  { key: '10INX12IN', title: '10INX12IN', ratio: 10 / 12 },
  { key: '10INX14IN', title: '10INX14IN', ratio: 10 / 14 },
  { key: '11INX14IN', title: '11INX14IN', ratio: 11 / 14 },
  { key: '11INX17IN', title: '11INX17IN', ratio: 11 / 17 },
  { key: '14INX14IN', title: '14INX14IN', ratio: 1 },
  { key: '14INX17IN', title: '14INX17IN', ratio: 14 / 17 },
  { key: '24CMX24CM', title: '24CMX24CM', ratio: 1 },
  { key: '24CMX30CM', title: '24CMX30CM', ratio: 24 / 30 },
  { key: 'A4', title: 'A4', ratio: 2480 / 3508 },
  { key: 'A3', title: 'A3', ratio: 3508 / 4961 },
];

export const MEDIUM_TYPE = [
  { key: 'PAPER', title: 'PAPER' },
  { key: 'CLEAR FILM', title: 'CLEAR FILM' },
  { key: 'BLUE FILM', title: 'BLUE FILM' },
  { key: 'MAMMO BLUE FILM', title: 'MAMMO BLUE FILM' },
  { key: 'MAMMO CLEAR FILM', title: 'MAMMO CLEAR FILM' },
];

export const MAGNIFICATION = [
  { key: 'REPLICATE', title: 'REPLICATE' },
  { key: 'BILINEAR', title: 'BILINEAR' },
  { key: 'CUBIC', title: 'CUBIC' },
  { key: 'NONE', title: 'NONE' },
];

export const TRIM = [
  { key: 'YES', title: 'YES' },
  { key: 'NO', title: 'NO' },
];

export const DESTINATION = [
  { key: 'MAGAZINE', title: 'MAGAZINE' },
  { key: 'PROCESSOR', title: 'PROCESSOR' },
];

export const PRIORITY = [
  { key: 'HIGH', title: 'HIGH' },
  { key: 'MED', title: 'MED' },
  { key: 'LOW', title: 'LOW' },
];

export const ORIENTATION = [
  { key: 'PORTRAIT', title: 'PORTRAIT' },
  { key: 'LANDSCAPE', title: 'LANDSCAPE' },
];

export const DENSITY_COLOR = [
  { key: 'BLACK', title: 'BLACK' },
  { key: 'WHITE', title: 'WHITE' },
];

export interface PrintExtraSettings {
  density_border: string;
  density_empty: string;
  density_max: string;
  density_min: string;
  // destination: string;
  film_size: string;
  magnification: string;
  medium_type: string;
  orientation: string;
  // priority: string;
  trim: string;
}

export interface PrintSettings extends PrintExtraSettings {
  // filenames: fileName,
  // image_display_format: 'STANDARD\\1,1',
  // institution_id: '86e65619-400e-41b4-b84a-06b80399022b',
  number_of_copies: number;
  film_size: string;
  orientation: string;
  // patient_name: 'jhfasdf',
  // study_description: 'fasdfaksdhaf',
  // study_instance_uid: '123.241606668321866.1760390403931932',
  // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  // trim: 'NO',
  type: PRINT_TYPE;
  // usecase: 'key_image';
}
